module.exports = __webpack_public_path__ + "static/media/voavanga.22c146bc.png";